export default "__VITE_ASSET__d7aa846d__"